import React, { useMemo, useState } from "react";
import { ArrowUpRight } from "lucide-react";

export default function Estimate({ language, mode, onQuote }) {
  const [squareFeet, setSquareFeet] = useState(1800);
  const [building, setBuilding] = useState("home");
  const annualSignal = useMemo(() => {
    const buildingFactor = building === "commercial" ? 1.25 : building === "multi" ? 1.1 : 1;
    const modeFactor = mode === "heat" ? 0.42 : 0.34;
    return Math.max(18, Math.round((squareFeet * modeFactor * buildingFactor) / 10) * 10);
  }, [building, mode, squareFeet]);
  const copy = language === "en" ? {
    label: "03 // Planning signal",
    title: "Start with the shape of the problem.",
    intro: "A quick planning signal helps frame the conversation. Your final recommendation comes after we understand the space.",
    size: "Approximate space",
    building: "Building type",
    home: "Single-family home",
    multi: "Multi-unit / condo",
    commercial: "Commercial space",
    result: "Indicative system signal",
    resultCopy: "A first-pass range for the conversation, not a quote or engineering calculation.",
    footnote: "Every building behaves differently. We confirm the right system, capacity, and scope with you.",
    button: "Bring this to Protech",
  } : {
    label: "03 // Señal de planificación",
    title: "Empieza por entender el problema.",
    intro: "Esta señal rápida ayuda a iniciar la conversación. La recomendación final llega después de conocer el espacio.",
    size: "Espacio aproximado",
    building: "Tipo de edificio",
    home: "Casa unifamiliar",
    multi: "Condominio / varias unidades",
    commercial: "Espacio comercial",
    result: "Señal indicativa del sistema",
    resultCopy: "Un primer rango para conversar, no una cotización ni un cálculo de ingeniería.",
    footnote: "Cada edificio se comporta diferente. Confirmamos contigo el sistema, capacidad y alcance correctos.",
    button: "Llevarlo a Protech",
  };

  return (
    <section className="estimate-section" id="estimate" data-testid="estimate-section">
      <div className="section-shell">
        <div className="section-header reveal"><span className="section-label">{copy.label}</span><div><h2 className="section-title">{copy.title}</h2><p className="section-intro">{copy.intro}</p></div></div>
        <div className="estimate-grid">
          <div className="estimate-panel reveal">
            <div className="form-field"><label className="form-label" htmlFor="square-feet-slider">{copy.size} <strong>{squareFeet.toLocaleString()} sq ft</strong></label><input id="square-feet-slider" className="range-input" type="range" min="800" max="10000" step="100" value={squareFeet} onChange={(event) => setSquareFeet(Number(event.target.value))} data-testid="calculator-sqft-slider" /></div>
            <div className="form-field"><label className="form-label" htmlFor="building-type-select">{copy.building}</label><select id="building-type-select" className="select-input" value={building} onChange={(event) => setBuilding(event.target.value)} data-testid="calculator-system-select"><option value="home">{copy.home}</option><option value="multi">{copy.multi}</option><option value="commercial">{copy.commercial}</option></select></div>
            <button className="button" type="button" onClick={onQuote} data-testid="calculator-submit-button">{copy.button} <ArrowUpRight /></button>
          </div>
          <div className="estimate-result reveal" data-testid="calculator-result">
            <div><span className="section-label">{copy.result}</span><div className="result-number">{annualSignal}%</div><p className="result-copy">{copy.resultCopy}</p></div>
            <p className="result-footnote">{copy.footnote}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
